import { z } from 'zod'

export const ZSignIn = z.object({
  username: z
    .string()
    .min(1, {
      message: '이메일 주소를 입력해 주세요.',
    })
    .email({
      message: '이메일 형식으로 입력해 주세요.',
    }),
  password: z.string().min(1, {
    message: '비밀번호를 입력해 주세요.',
  }),
  rememberMe: z.boolean(),
})

export type TSignIn = z.infer<typeof ZSignIn>
